export class SecretConfigurationViewModel {
    static createDefault() {
        return {};
    }
}
